function setTagalysConfiguration() {
  const configuration = {
    api: {
      serverUrl: window.tagalysConfiguration.serverUrl,
      apiKey: window.tagalysConfiguration.apiKey
    },
    locale: window.tagalysConfiguration.locale,
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: window.tagalysConfiguration.currencyCode,
      label: window.tagalysConfiguration.currencySymbol,
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: function() {
      // return true/false based on user's consent settings
      return true;
    },
    track: true
  };
  Tagalys.setConfiguration(configuration);
}

function setPlatformConfigurationForTagalys() {
  var platformConfiguration = {
    platform: "Shopify",
    countryCode: Shopify.country,
    baseCountryCode: window.tagalysConfiguration.baseCountryCode,
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: window.tagalysConfiguration.storefrontAPIToken,
      myShopifyDomain: Shopify.shop
    },
    metafields: {
      products: []
    }
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
}

function onTagalysReady(callback) {
  if (window.Tagalys) {
    setTagalysConfiguration();
    setPlatformConfigurationForTagalys();
    callback();
  } else {
    window.addEventListener("DOMContentLoaded", function () {
      setTagalysConfiguration();
      setPlatformConfigurationForTagalys();
      callback();
    });
  }
}